/**
 * Renders the GILDer logo (shield + wordmark). `tone="light"` (default)
 * uses the gold-on-dark wordmark for use against dark backgrounds (top
 * navbar, sidebar). `tone="dark"` swaps to the dark variant intended for
 * light surfaces such as the wallet-connect modal. `size` controls the
 * rendered width; height is proportional.
 */
export default function Brand({ tone = "light", size = "md" }) {
    const widthClass =
        size === "lg" ? "w-[120px]" : size === "sm" ? "w-[96px]" : "w-[140px]";
    const src = tone === "dark" ? "/images/dark-logo.png" : "/images/logo.png";

    return (
        <div className="flex items-center">
            <img src={src} alt="GILDer" className={`${widthClass} h-auto`} />
        </div>
    );
}
